const footerLinks = [
  {
    title: '漫画分类',
    links: [
      { label: '韩漫全集', href: '#index' },
      { label: '日漫经典', href: '#index' },
      { label: '国漫精选', href: '#index' },
      { label: '恋爱甜宠', href: '#index' },
      { label: '奇幻冒险', href: '#index' },
    ],
  },
  {
    title: '阅读体验',
    links: [
      { label: '下拉式阅读', href: '#features' },
      { label: '连续阅读', href: '#features' },
      { label: '手机端阅读', href: '#app' },
      { label: '热门排行', href: '#ranking' },
      { label: '更新快讯', href: '#updates' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { label: '品牌故事', href: '#about' },
      { label: '投稿合作', href: '#contact' },
      { label: '常见问答', href: '#faq' },
      { label: '精选专题', href: '#carousel' },
      { label: '精彩视频', href: '#media' },
    ],
  },
  {
    title: '合作伙伴',
    links: [],
  },
];

export default function Footer() {
  const scrollTo = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="bg-background-800 text-background-200">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto py-14 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-12">
          {footerLinks.map((col) => (
            <div key={col.title}>
              <h4 className="text-sm font-semibold text-background-50 mb-4">
                {col.title}
              </h4>
              <ul className="space-y-2.5">
                {col.links.length > 0 ? (
                  col.links.map((link) => (
                    <li key={link.label}>
                      <a
                        href={link.href}
                        onClick={(e) => { e.preventDefault(); scrollTo(link.href); }}
                        className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer"
                      >
                        {link.label}
                      </a>
                    </li>
                  ))
                ) : (
                  <li>
                    <span className="text-sm text-background-500">
                      诚邀合作
                    </span>
                  </li>
                )}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-background-700 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
              <i className="ri-book-read-line text-background-50 text-sm"></i>
            </div>
            <div>
              <p className="text-sm text-background-100 font-semibold">布丁漫画网</p>
              <p className="text-xs text-background-500">布丁漫画下拉式免费看</p>
            </div>
          </div>

          <p className="text-xs text-background-500 text-center">
            &copy; 2026 布丁漫画网 - 布丁漫画全集下拉式连续阅读免费体验
          </p>

          <div className="flex items-center gap-4">
            <a href="#hero" onClick={(e) => { e.preventDefault(); scrollTo('#hero'); }} className="text-background-500 hover:text-background-200 transition-colors cursor-pointer">
              <i className="ri-wechat-line text-lg"></i>
            </a>
            <a href="#hero" onClick={(e) => { e.preventDefault(); scrollTo('#hero'); }} className="text-background-500 hover:text-background-200 transition-colors cursor-pointer">
              <i className="ri-weibo-line text-lg"></i>
            </a>
            <a href="#hero" onClick={(e) => { e.preventDefault(); scrollTo('#hero'); }} className="text-background-500 hover:text-background-200 transition-colors cursor-pointer">
              <i className="ri-bilibili-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}